























import {
    mapGetters,
} from 'vuex';

export default {
    props: {
        isHorizontal: {
            type: Boolean,
            default: false,
            required: false,
        },
        size: {
            type: String,
            default: 'small',
            validator(input) {
                return ['small', 'medium', 'large'].includes(input);
            },
        },
        storeRegulation: {
            type: String,
            default: 'international',
        },
    },
    computed: {
        ...mapGetters('remoteConfig', ['remoteConfigByKey']),
    },
    methods: {
        getAppLink(store) {
            return this.remoteConfigByKey('appStoreUrl')[this.storeRegulation][store];
        },
    },
};
